/* Common Imports */

import { styled, useTheme } from "@mui/system";

/* Redux & Type Imports */

import { NextRouter } from "next/router";
import StateInterface from "../../../../redux-magic/state-interface";
import { setOpenChatModalThunk } from "../../../../redux-magic/store";

/* Component Imports */

import { IconButton, Typography } from "@mui/material";

/* Icon Imports */

import { Close } from "@mui/icons-material";

/* Styled Components */

const RootDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	background: theme.palette.background.paper,
	backgroundColor: '#F6F6F6',
	cursor: "pointer",
	padding: "1rem 0.25rem 1rem 0.5rem",
	position: "sticky",
	top: 0,
	[theme.breakpoints.up("md1190")]: {
		padding: "1.5rem 1.25rem 1rem 1.25rem",
	},
}));

const RowContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
}));

const ProfilePicture = styled("img")(({ theme }) => ({
	borderRadius: "0.5rem",
	boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
	height: "2.5rem",
	width: "2.5rem",
	objectFit: "cover",
	[theme.breakpoints.up("md1190")]: {
		height: "2.5rem",
		width: "2.5rem",
	},
}));

const TitleCard = styled(Typography)(({ theme }) => ({
	fontSize: "1rem",
	fontWeight: 500,
	lineHeight: "1.25rem",
	[theme.breakpoints.up("md1190")]: {
		fontSize: "1.125rem",
	},
}));

const ChatListHeader = ({
	session,
	dispatch,
	router,
	profile_context,
	loading,
	profilePicture,
}: {
	session: StateInterface["redux_session"];
	dispatch: Function;
	router: NextRouter;
	profile_context: any;
	loading: boolean;
	profilePicture: string;
}) => {
	const theme = useTheme();

	/* Translations */

	const localLang = {
		chats: router.locale === "ar-AE" ? "الدردشات" : router.locale === "kn-IN" ? "ಚಾಟ್‌ಗಳು" : "Chats",
		messages: router.locale === "ar-AE" ? "الرسائل" : router.locale === "kn-IN" ? "ಸಂದೇಶಗಳು" : "Messages",
		close: router.locale === "ar-AE" ? "إغلاق" : router.locale === "kn-IN" ? "ಮುಚ್ಚಿ" : "Close",
	};

	return (
		// Only the close button closes the drawer: a click on the avatar or the name used to as well.
		<RootDiv>
			<RowContainer sx={{ gap: "1rem" }}>
				{/* Profile Picture */}

				{!profilePicture.includes("/images/icons/Avatar.svg") ? (
					<ProfilePicture
						src={`/profile-picture/${profilePicture}`}
						alt={localLang.chats}
						referrerPolicy="no-referrer"
					/>
				) : (
					<ProfilePicture
						src={profilePicture}
						alt={localLang.chats}
						referrerPolicy="no-referrer"
					/>
				)}

				{/* Name */}

				<TitleCard variant="body1">{profile_context?.page_title}</TitleCard>
			</RowContainer>

			<IconButton
				aria-label="close"
				onClick={() => dispatch(setOpenChatModalThunk(false))}
			>
				<Close
					sx={{
						color: theme.palette.text.disabled,
						fontSize: "1.75rem",
					}}
				/>
			</IconButton>
		</RootDiv>
	);
};

export default ChatListHeader;
